<div class="modal fade" bsModal #addAppealModal="bs-modal" [config]="{backdrop: true}"
     tabindex="-1" role="dialog" aria-hidden="true" (onShow)="showModalInit()">
    @if (newAppeal) {
        <div class="modal-dialog modal-sm">
            <div class="modal-content">
                <ws-modal-wrapper headerLabel="Add Appeal"
                                  acceptLabel="Add"
                                  [loading]="loading"
                                  (save)="save()"
                                  (cancel)="addAppealModal.hide()">
                    <div class="row">
                        <div class="col-8">
                            <label>
                                <span>Appeal Level:</span>
                                <select class="form-select form-select-sm" [(ngModel)]="newAppeal.appealLevelID" (ngModelChange)="onAppealLevelChange()" style="width: 200px;">
                                    @for (level of appealLevels; track level) {
                                        <option [ngValue]="level.appealLevelID">{{ level.abbr }}</option>
                                    }
                                </select>
                            </label>
                        </div>
                        <div class="mt-1">
                            <span>Litigation: {{ isAppealLevelLitigation ? 'Yes' : 'No' }}</span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-8">
                            <label>
                                <span>Revision Appealed:</span>
                                <select class="form-select form-select-sm" [(ngModel)]="newAppeal.annualAssessmentID" style="width: 200px;">
                                    @for (assessment of assessments; track assessment) {
                                        <option
                                            [ngValue]="assessment.annualAssessmentID">{{ assessment.revisionDesc }}
                                        </option>
                                    }
                                </select>
                            </label>
                        </div>
                    </div>
                    @if (shouldShowLitigationReferralTask) {
                        <div class="row mt-2">
                            <div class="col-12">
                                <label class="d-flex align-items-center gap-2">
                                    <input type="checkbox" [(ngModel)]="addLitigationReferralTask" />
                                    Add litigation referral task to appeal and check the RLS checkbox
                                </label>
                            </div>
                        </div>
                    }
                </ws-modal-wrapper>
            </div>
        </div>
    }
</div>
